import { render, staticRenderFns } from "./FeaturedTile.vue?vue&type=template&id=2f1ecf78&scoped=true"
import script from "./FeaturedTile.vue?vue&type=script&lang=js"
export * from "./FeaturedTile.vue?vue&type=script&lang=js"
import style0 from "./FeaturedTile.vue?vue&type=style&index=0&id=2f1ecf78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ecf78",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedTile.vue
// module id = 289
// module chunks = 0